import React, { useEffect, useState } from "react";
import API from "../api/axios";
import { useNavigate } from "react-router-dom";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const navigate =useNavigate();
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await API.get("/categories");
        setCategories(data);
      } catch (error) {
        console.error("❌ Error obteniendo categorías:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="container mx-auto mt-10 px-4">
      <h2 className="text-2xl font-bold text-center mb-6">Explora por Categoría 🔍</h2>
      <div className="flex justify-center gap-6 flex-wrap">
        {categories.length > 0 ? (
          categories.map((category) => (
            <div key={category._id} className="flex flex-col items-center" onClick={() => navigate(`/category/${category.name}`)}>
              <div className="w-24 h-24 bg-white rounded-full shadow-md flex items-center justify-center hover:scale-105 transition-transform">
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}/uploads/categoryImage/${category.image}`}
                  alt={category.name}
                  className="w-20 h-20 rounded-full object-cover"
                />
              </div>
              <p className="mt-2 text-sm font-semibold text-center">{category.name}</p>
            </div>
          ))
        ) : (
          <p className="text-center">No hay categorías disponibles.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryList;
